//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { mapCopy } from 'src/util/helper';
import validation, { required, phone } from 'src/util/validation';


export default {
	name: 'OfferRequest',
	mixins: [validation],

	data: () => ({
		loading: false,
		checked: false,
		ads: false,
		indivAds: false,
		fullService: false,
		...mapCopy('currentUser', ['phoneNumber']),
	}),

	validation: {
		phoneNumber: [
			required('Bitte geben Sie eine gültige Telefonnummer an!'),
			phone('Bitte geben Sie eine gültige Telefonnummer an!'),
		],
		checked: [
			required('Bitte lesen Sie die AGB und Datenschutzrichtlinien!'),
		],
	},

	computed: {
		...mapState('subscription', ['pricing', 'period', 'product']),
	},

	methods: {
		async requestOffer() {
			const validated = await this.validate();
			if (!validated) return;

			this.loading = true;

			await this.$store.dispatch('subscription/requestOffer', {
				type: this.product,
				period: this.period,
				phoneNumber: this.phoneNumber,
				interests: [
					... this.ads ? ['Inserate & Retargeting auf dem Facebook Marketplace'] : [],
					... this.indivAds ? ['Individuelle Werbekampagnen um Angebote zu bewerben'] : [],
					... this.fullService ? ['Full-Service Social-Media-Marketing'] : [],
				],
			});

			this.$router.push('/payment/offerconfirmation');

			this.loading = false;
		},

	},

};
